import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-recovery-report-form',
  templateUrl: './recovery-report-form.component.html',
  styleUrls: ['./recovery-report-form.component.css']
})
export class RecoveryReportFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/recovery/recovery-reports/recovery-report-form/recovery-report-form.component.ts